<!--
 * @Author: 71
 * @Date: 2026-06-12 09:54:53
 * @LastEditTime: 2026-06-24 14:03:17
 * @LastEditors: 71
 * @Description: 
 * @FilePath: \aigoes-school-web\src\views\school\AppPage\ HundredDayOath\compoents\ActivityEmotionSpacePane.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <div class="container">
    <div class="content">
      <!-- 第一部分：学校管理 -->
      <activity-emotion-space-section1 ref="section1" />
      <!-- 第二部分：试用详情 -->
      <activity-emotion-space-section2 ref="section2" />
    </div>
  </div>
</template>

<script>
import ActivityEmotionSpaceSection1 from './model/ActivityEmotionSpaceSection1.vue'
import ActivityEmotionSpaceSection2 from './model/ActivityEmotionSpaceSection2.vue'

export default {
  name: 'ActivityEmotionSpacePane',
  components: {
    ActivityEmotionSpaceSection1,
    ActivityEmotionSpaceSection2,
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
